
<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <form [formGroup]="ocorrenciaForm" class="row" fxLayout="row wrap">

    <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="25" class="p-1">
      <mat-label>Data da Ocorrência</mat-label>
      <input matInput [matDatepicker]="pickerData" formControlName="dataOcorrencia" />
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="pickerData"></mat-datepicker-toggle>
      <mat-datepicker #pickerData startView="month"></mat-datepicker>
      <mat-error>Informe a data.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="45" class="p-1">
      <mat-label>Avisar</mat-label>
      <mat-select formControlName="avisar" [compareWith]="compareAvisar">
        <mat-option *ngFor="let opt of avisarOptions" [value]="opt">
          {{ opt.descricao }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="30" class="p-1">
      <mat-label>Status</mat-label>
      <input matInput formControlName="status" maxlength="255" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100" class="p-1">
      <mat-label>Ocorrência</mat-label>
      <textarea matInput formControlName="ocorrencia" rows="4"
        placeholder="Descreva a ocorrência..."></textarea>
      <mat-error>Informe a ocorrência.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="50" class="p-1">
      <mat-label>Avisar a partir de</mat-label>
      <input matInput [matDatepicker]="pickerIni" formControlName="dataAvisarInicial" />
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="pickerIni"></mat-datepicker-toggle>
      <mat-datepicker #pickerIni startView="month"></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="50" class="p-1">
      <mat-label>Avisar até</mat-label>
      <input matInput [matDatepicker]="pickerFim" formControlName="dataAvisarFinal" />
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
      <mat-datepicker #pickerFim startView="month"></mat-datepicker>
    </mat-form-field>

  </form>
</div>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>
    {{"CLOSE" | translate }}
  </button>
  <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="isSaving">
    <mat-icon>save</mat-icon>
    {{"SAVE" | translate }}
  </button>
</mat-dialog-actions>
